import { useCallback, useDebugValue, useState } from 'react'

type ChatDrawerState = {
  isOpen: boolean
  isMounted: boolean
  open: () => void
  close: () => void
  onClosed: () => void
}

/**
 * Manages the state of the chat drawer.
 */
export function useChatDrawer(): ChatDrawerState {
  const [{ isOpen, isMounted }, setDrawerState] = useState({ isOpen: false, isMounted: false })

  useDebugValue(isOpen ? 'opened' : 'closed')

  const open = useCallback(() => {
    setDrawerState(previousState => ({ ...previousState, isOpen: true, isMounted: true }))
  }, [])

  const close = useCallback(() => {
    setDrawerState(previousState => ({ ...previousState, isOpen: false }))
  }, [])

  const onClosed = useCallback(() => {
    setDrawerState(previousState => ({ ...previousState, isMounted: false }))
  }, [])

  return {
    isOpen,
    isMounted,
    open,
    close,
    onClosed,
  }
}
